import { graphql } from 'react-relay';
export const SpaceNameQuery = graphql`
	query SpaceNameQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			name
			key
		}
	}
`;
